import {Component, inject} from '@angular/core';
import {BaseComponent} from "@app/core/bases";
import {CommonModule} from "@angular/common";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {CardModule} from "primeng/card";
import {ButtonModule} from "primeng/button";
import {MenuModule} from "primeng/menu";
import {RippleModule} from "primeng/ripple";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {TagModule} from "primeng/tag";
import {RouterLink} from "@angular/router";
import {EbpService, UtilityService} from "@app/core/services";
import {environment} from "@env/environment";

interface Column {
    field: string;
    header: string;
}

@Component({
  selector: 'app-ebp-error',
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        ButtonModule,
        MenuModule,
        RippleModule,
        ConfirmDialogModule,
        ToastModule,
        TagModule,
        RouterLink,
    ],
  templateUrl: './ebp-error.html'
})
export class EbpError extends BaseComponent {
    ebpService: EbpService = inject(EbpService);
    utilityService: UtilityService = inject(UtilityService);
    ebpStocks: any[] = [];
    selectedEbpStock!: any | null;

    resultsLength = 0;
    pageIndex = 0;
    pageSize = 20;
    sort!: { field: string, order: number };

    cols: Column[] = [
        { field: 'produit_id', header: 'ID Produit' },
        { field: 'etat', header: 'État' },
        { field: 'marque', header: 'Marque' },
        { field: 'reference', header: 'Référence' },
        { field: 'date_update', header: "Date de modification" },
    ];
    selectedColumns: Column[] = this.cols;

    isLoadingResults = true;
    isLoadedFromStorage = false;

    getTableEntries() {
        this.isLoadingResults = true;

        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.ebpService.getStocks({
            page: this.pageIndex + 1,
            size: this.pageSize,
            order_by: this.sort?.field,
            order: this.sort?.order === 1 ? 'asc' : 'desc',
        }).subscribe({
            next: (data) => {
                this.ebpStocks = data.results;
                this.resultsLength = data.total;
            },
            error: (err) => {
                this.isLoadingResults = false;
                console.error(err);
            },
            complete: () => {
                this.isLoadingResults = false;
                this.apiCall$?.unsubscribe();
            }
        });
    }

    onLazyLoad(event: TableLazyLoadEvent) {
        this.pageIndex = event.first! / event.rows!;
        this.pageSize = event.rows!;
        this.sort = { field: event.sortField as string, order: event.sortOrder as number };
        this.getTableEntries();
    }

    onStateRestore(state: any) {
        // Called when dt table restores state from storage
        this.isLoadedFromStorage = true;
        try {
            if (state && state.first !== undefined && state.rows) {
                this.pageIndex = state.first / state.rows;
            }
        } catch (e) {
            // ignore, justepour évité des erreurs si le state n'est pas conforme
        }
    }

    onRetry() {
        this.ebpService.postResendErrors().subscribe({
            next: () => {
                this.toastService.add({ severity: 'success', summary: 'Succès', detail: 'Les stocks en erreurs ont bien été envoyés vers EBP.\n Cette action peut prendre un certain temps.', life: 90000 });
            },
            error: (err) => {
                console.error(err);
            },
        })
    }

    protected readonly environment = environment;
}
